
import { QuizPreferences } from '@/types/quiz';

export const getDestinationScore = (destination: any, preferences: QuizPreferences) => {
  let score = 0;
  const weights = {
    major: 5,
    medium: 3,
    minor: 1
  };

  // Comfort Zone & Planning Style scoring
  if (preferences.comfortZone === 'unknown') {
    if (destination.unique_experiences?.off_the_beaten_path) score += weights.major;
    if (!destination.tourism_data?.unesco_sites) score += weights.medium;
  } else if (preferences.comfortZone === 'familiar') {
    if (destination.tourism_data?.unesco_sites) score += weights.major;
    if (destination.tourism_data?.top_attractions?.length > 0) score += weights.medium;
  }

  // Interest Focus scoring
  if (preferences.interestFocus === 'culture') {
    if (destination.tourism_data?.unesco_sites) score += weights.major;
    if (destination.tourism_data?.famous_festivals) score += weights.major;
    if (destination.cultural_insights?.cultural_etiquette) score += weights.medium;
  } else if (preferences.interestFocus === 'nature') {
    if (destination.nearby_natural_features?.length > 0) score += weights.major;
    if (destination.has_beach) score += weights.medium;
    if (destination.is_coastal) score += weights.medium;
  } else if (preferences.interestFocus === 'blend') {
    if (destination.nearby_natural_features?.length > 0) score += weights.medium;
    if (destination.tourism_data?.unesco_sites) score += weights.medium;
    if (destination.has_beach || destination.tourism_data?.famous_festivals) score += weights.minor;
  }

  // Experience Type scoring
  if (preferences.experienceType === 'quirky') {
    if (destination.unique_experiences?.off_the_beaten_path) score += weights.major;
    if (!destination.tourism_data?.top_attractions?.length) score += weights.medium;
  } else if (preferences.experienceType === 'classic') {
    if (destination.tourism_data?.top_attractions?.length > 2) score += weights.major;
    if (destination.tourism_data?.unesco_sites) score += weights.medium;
  }

  // Budget considerations
  const avgDailyBudget = destination.costs_infrastructure?.avg_daily_budget;
  if (avgDailyBudget) {
    if (preferences.budget === 'budget' && avgDailyBudget < 50) score += weights.major;
    else if (preferences.budget === 'luxury' && avgDailyBudget > 200) score += weights.major;
    else if (preferences.budget === 'moderate' && avgDailyBudget >= 50 && avgDailyBudget <= 150) score += weights.major;
  }

  // Journey Preference
  if (preferences.journeyPreference === 'scenic') {
    if (!destination.transportation_data?.major_transport_hub) score += weights.medium;
    if (destination.transportation_data?.inter_city_train_station) score += weights.medium;
  } else if (preferences.journeyPreference === 'direct') {
    if (destination.transportation_data?.major_transport_hub) score += weights.major;
    if (destination.transportation_data?.nearest_international_airport) score += weights.medium;
  }

  // Connectivity Needs
  if (preferences.connectivityNeeds === 'connected') {
    if (destination.costs_infrastructure?.internet_speed_avg > 50) score += weights.medium;
    if (destination.costs_infrastructure?.free_wifi_availability) score += weights.minor;
  } else if (preferences.connectivityNeeds === 'disconnect') {
    if (!destination.costs_infrastructure?.free_wifi_availability) score += weights.medium;
    if (destination.unique_experiences?.off_the_beaten_path) score += weights.medium;
  }

  // Transformation Openness
  if (preferences.transformationOpenness === 'transformative') {
    if (destination.unique_experiences?.off_the_beaten_path) score += weights.medium;
    if (destination.cultural_insights?.cultural_etiquette) score += weights.medium;
  } else if (preferences.transformationOpenness === 'comfortable') {
    if (destination.tourism_data?.top_attractions?.length > 0) score += weights.medium;
    if (destination.costs_infrastructure?.healthcare_access === 'good') score += weights.minor;
  }

  // Normalize score to 0-100 range
  const maxPossibleScore = weights.major * 8; // Approximate max score possible
  const normalizedScore = Math.round((score / maxPossibleScore) * 100);
  
  return Math.min(normalizedScore, 100); // Cap at 100
};
